import { RHSR_LOGO, VSR_LOGO } from '@generated/components/AdGuide';
import { money } from '@generated/components/pricing';

export interface ReceiptInfo { kind: string; who?: string; ref: string; amount: number; method: string; date?: Date; details?: { label: string; value: string }[] }

const esc = (s: string) => s.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c] ?? c));
const day = (d: Date) => d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric', timeZone: 'America/New_York' });

/** Plain-text receipt (for email). */
export function receiptText(r: ReceiptInfo): string {
  return [
    'RECEIPT · The Star-Revue',
    'Red Hook Star-Revue & The Village Star-Revue',
    'George Fiala, Publisher · 917-652-9128 · gbrook8344@gmail.com',
    '',
    `Date: ${day(r.date ?? new Date())}`,
    `Received from: ${r.who || '—'}`,
    `For: ${r.kind} (ref. ${r.ref})`,
    `Amount: ${money(r.amount)}`,
    `Paid by: ${r.method}`,
    '',
    'Thank you for supporting your community newspapers.',
  ].join('\n');
}

/** Opens a printable receipt with the RHSR logo (customer can print or save as PDF). */
export function openReceipt(r: ReceiptInfo) {
  const w = window.open('', '_blank', 'width=720,height=900');
  if (!w) return false;
  const row = (k: string, v: string) => `<tr><th>${esc(k)}</th><td>${esc(v)}</td></tr>`;
  w.document.write(`<!doctype html><html><head><title>Receipt · Star-Revue</title><style>
    body{font-family:Georgia,serif;color:#1d2433;max-width:560px;margin:40px auto;padding:0 24px}
    header{display:flex;gap:16px;align-items:center;border-bottom:3px double #1d2433;padding-bottom:12px}
    header img{width:80px;height:80px} h1{margin:0;font-size:28px} .sub{font:13px system-ui,sans-serif;color:#555}
    table{width:100%;border-collapse:collapse;margin-top:20px;font:15px system-ui,sans-serif}
    th{text-align:left;color:#555;font-weight:600;width:38%;padding:8px 0;border-bottom:1px solid #ddd} td{padding:8px 0;border-bottom:1px solid #ddd}
    .amt td{font-size:22px;font-weight:700} p{font:13px system-ui,sans-serif;color:#555} button{margin-top:20px;padding:10px 18px;font-weight:600}
    @media print{button{display:none}}</style></head><body>
    <header><img src="${RHSR_LOGO}" alt="Red Hook Star-Revue logo"><img src="${VSR_LOGO}" alt="The Village Star-Revue logo"><div><h1>Receipt</h1><div class="sub">Red Hook Star-Revue &amp; The Village Star-Revue<br>George Fiala, Publisher · 917-652-9128 · gbrook8344@gmail.com</div></div></header>
    <table>${row('Date', day(r.date ?? new Date()))}${row('Received from', r.who || '—')}${row('For', `${r.kind} (ref. ${r.ref})`)}${(r.details ?? []).map((d) => row(d.label, d.value)).join('')}${row('Paid by', r.method)}<tr class="amt"><th>Amount</th><td>${esc(money(r.amount))}</td></tr></table>
    <p>Thank you for supporting your community newspapers.</p>
    <button onclick="window.print()">Print or save as PDF</button></body></html>`);
  w.document.close();
  return true;
}
